module.exports = __webpack_public_path__ + "static/img/029.5516b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/029.png
// module id = bkqW
// module chunks = 0